module.exports = __webpack_public_path__ + "static/cards-7694cc8042794f4b89ac6f2461a035f4.svg";